module.exports = __webpack_public_path__ + "img/bubble_layout_3.a70e7358.png";